<template>
<div class="m-punchkingwinners" v-if="loaded">
  <div class="m-pkw__header" v-observe-visibility="observeVisibilitySettings(0, 'Header')">
    <span class="m-pkw__title">World's Best Punch King</span>
    <span class="m-pkw__subtitle">Here Are the #1 Top-Ranked Winners of the World's Best Punch King Event.</span>
    <img class="m-pkw__characterslogo" alt="Characters and Logo" src="@/assets/images/microsites/punchkingwinners/characters_logo.png" />
    <img class="m-pkw__characterslogo_mobile" alt="Characters and Logo" src="@/assets/images/microsites/punchkingwinners/characters_logo_mobile.png" />
  </div>
  <div class="m-pkw__nav" ref="pkwNav">
    <div class="m-pkw__nav_toggles">
      <div class="m-pkw__nav_toggles_container m-pkw__nav_toggles_region">
        <div class="m-pkw__nav_toggles-toggle" :class="`${regionToggle === 'na' ? 'active' : ''}`" @click="setRegionToggle('na')">NA</div>
        <div class="m-pkw__nav_toggles-toggle" :class="`${regionToggle === 'eu' ? 'active' : ''}`" @click="setRegionToggle('eu')">EU</div>
        <div class="m-pkw__nav_toggle_active" :class="`${regionToggle === 'eu' ? 'right' : ''}`"></div>
      </div>
      <div v-if="regionToggle === 'na'" class="m-pkw__nav_toggles_container m-pkw__nav_toggles_world m-pkw__nav_toggles_world_na">
        <div class="m-pkw__nav_toggles-toggle" :class="`${rebootType === 0 ? 'active' : ''}`" @click="setRebootType(0)">Bera, Scania, Aurora, Elysium Worlds</div>
        <div class="m-pkw__nav_toggles-toggle" :class="`${rebootType === 1 ? 'active' : ''}`" @click="setRebootType(1)">Reboot World</div>
        <div class="m-pkw__nav_toggle_active" :class="`${rebootType === 1 ? 'right' : ''}`"></div>
      </div>
      <div v-if="regionToggle === 'eu'" class="m-pkw__nav_toggles_container m-pkw__nav_toggles_world m-pkw__nav_toggles_world_eu">
        <div class="m-pkw__nav_toggles-toggle" :class="`${rebootType === 0 ? 'active' : ''}`" @click="setRebootType(0)">Luna World</div>
        <div class="m-pkw__nav_toggles-toggle" :class="`${rebootType === 1 ? 'active' : ''}`" @click="setRebootType(1)">Reboot World</div>
        <div class="m-pkw__nav_toggle_active" :class="`${rebootType === 1 ? 'right' : ''}`"></div>
      </div>
    </div>
    <div class="m-pkw__nav_links">
      <div class="m-pkw__nav_link" @click="toggleModal(true)">
        <div class="m-pkw__star"></div>
        <span>Top 10 Ranked Maplers</span>
        <div class="m-pkw__star"></div>
      </div>
      <div class="m-pkw__nav_link" @click="goToRewards">
        <div class="m-pkw__star"></div>
        <span>Rewards</span>
        <div class="m-pkw__star"></div>
      </div>
    </div>
  </div>
  <div class="m-pkw__rankings">
    <div class="m-pkw__rankings-list">
      <div v-for="(character, _index) in filteredRankings" :key="_index" class="m-pkw__rankings-item">
        <div class="m-pkw__rankings-item-header">{{character.jobName}}</div>
        <img alt="Character Avatar" class="m-pkw__rankings-item-avatar" :src="character.characterImgURL" />
        <div class="m-pkw__rankings-item-footer">
          <span>{{character.characterName}}</span>
          <img :alt="`World ${getCharacterWorld(character)}`" class="m-pkw__rankings-item-footer-icon" :src="require(`@/assets/images/microsites/punchkingwinners/worlds/${getCharacterWorld(character)}.png`)" />
        </div>
      </div>
    </div>
    <div class="m-pkw__asterisk">
      <span>*Job names are listed alphabetically.&nbsp;&nbsp;&nbsp;*Character name and image reflect the data at the end of the event.</span>
    </div>
    <div class="m-pkw__rewards" ref="pkwRewards" v-observe-visibility="observeVisibilitySettings(2, 'Reward Details')">
      <div class="m-pkw__rewards-header">
        <div class="m-pkw__rewards-header-deco"></div>
        <span>Reward Details</span>
        <div class="m-pkw__rewards-header-deco"></div>
      </div>
      <div class="m-pkw__rewards-retrieval">
        <strong>Reward Retrieval</strong>:<br /> October 18, 2023 12:00 AM UTC - October 31, 2023 11:59 PM UTC
      </div>
      <div class="m-pkw__rewards-items">
        <div class="m-pkw__rewards-item">
          <img alt="Reward Border" class="m-pkw__rewards-item-border" src="@/assets/images/microsites/punchkingwinners/decos/reward_border.png" />
          <div class="m-pkw__reward-item-header">
            <div class="m-pkw__star"></div>
            <span>Top 10 Ranked Players Receive</span>
            <div class="m-pkw__star"></div>
          </div>
          <div class="m-pkw__reward-title">
            World's Best Punch King Chair:
          </div>
          <div class="m-pkw__reward-subtitle">
            Displays the highest rank you achieved (1 to 10) when used.
          </div>
          <img class="m-pkw__reward-chair" alt="Reward Chair" src="@/assets/images/microsites/punchkingwinners/characters/reward_chair.png" />
        </div>
        <div class="m-pkw__rewards-item">
          <img alt="Reward Border" class="m-pkw__rewards-item-border" src="@/assets/images/microsites/punchkingwinners/decos/reward_border.png" />
          <div class="m-pkw__reward-item-header">
            <div class="m-pkw__star"></div>
            <span>#1 Ranked Players Also Receive</span>
            <div class="m-pkw__star"></div>
          </div>
          <div class="m-pkw__reward-title">
            World's Best Effect:
          </div>
          <div class="m-pkw__reward-subtitle">
            Displays an effect engraved with a design specific to your job.
          </div>
          <carousel class="m-pkw__reward-carousel" ref="pkwRewardCarousel" :items-to-show="1" :transition="1000" :wrap-around="true" @slide-end="trackCarousel">
            <slide v-for="character in carouselCharacters" :key="character">
              <div class="m-pkw__carousel-bubble">{{character}}</div>
              <img :alt="`burst ${character}`" class="m-pkw__carousel-burst" :src="require(`@/assets/images/microsites/punchkingwinners/characters/burst_${character}.png`)" />
              <img :alt="`character ${character}`" :class="`${`m-pkw__carousel-character m-pkw__carousel-character__${character}`}`" :src="require(`@/assets/images/microsites/punchkingwinners/characters/character_${character}.png`)" />
            </slide>
            <template #addons>
              <Pagination />
            </template>
          </carousel>
        </div>
      </div>
      <div class="m-pkw__rewards-claim">Claim your reward(s) via [Punch King Rewards] from the event notifier on the <br class="m-pkw__rewards-claim_br_mobile"/>left-side of the screen. Rewards can only be claimed by the character<br class="m-pkw__rewards-claim_br"/> registered <br class="m-pkw__rewards-claim_br_mobile"/>on these rankings. <strong>Make sure to claim your rewards before the last day!</strong></div>
    </div>
  </div>
  <div class="m-pkw__play">
    <div @click="playFree">Play Maplestory Now</div>
  </div>
  <Transition name="m-pkw__popup">
    <div class="m-pkw__modal" v-if="modalRegionWorldFilter" @click.self="toggleModal(false)">
      <div class="m-pkw__modal-content">
        <div class="m-pkw__modal-close" @click="toggleModal(false)"></div>
        <div class="m-pkw__modal-title">
          <div class="m-pkw__modal-title-deco"></div>
          <span>Top 10 Ranked Maplers</span>
          <div class="m-pkw__modal-title-deco"></div>
        </div>
        <div class="m-pkw__modal-note">Note: Characters had to earn a perfect score of 1,500 points to appear on the rankings!<br />Some rankings may display fewer than 10 characters as a result.</div>
        <div class="m-pkw__modal-filters">
          <select v-model="modalRegionWorldFilter" @change="modalRegionWorldFilterChange(modalRegionWorldFilter)">
            <option v-for="filter in modalRegionWorldFilters" :key="filter.name" :value="filter">{{filter.name}}</option>
          </select>
          <select v-model="modalJobNameFilter" @change="trackModalFilter(`Job - ${modalJobNameFilter}`)">
            <option v-for="jobName in modalJobList" :key="jobName" :value="jobName">{{jobName}}</option>
          </select>
        </div>
        <div class="m-pkw__modal-ranking">
          <div>
            <div>Rank</div>
            <div>World</div>
            <div>Character</div>
          </div>
          <div v-for="character in filteredModalRankings" :key="character.characterName">
            <div>{{character.rank}}</div>
            <div>
              <img :alt="`World ${getCharacterWorld(character)}`" :src="require(`@/assets/images/microsites/punchkingwinners/worlds/${getCharacterWorld(character)}.png`)" />
            </div>
            <div>{{character.characterName}}</div>
          </div>
        </div>
        <div class="m-pkw__modal-asterisk">*Job names are listed alphabetically.&nbsp;&nbsp;&nbsp;<br />*Character name and image reflect the data at the end of the event.</div>
      </div>
    </div>
  </Transition>
</div>
</template>

<script>
import Util from '@/services/browser/Util';
import Responsive from '@/services/browser/Responsive'
import '@/assets/scss/microsites/punchkingwinners/_punchkingwinners.scss'
import { defineComponent } from 'vue'
import { ObserveVisibility } from 'vue-observe-visibility'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination } from 'vue3-carousel'

import _RANKINGS from './punchking_rank.json';

const _CAROUSEL_CHARACTERS = ['ark', 'mercedes', 'kinesis'];
const _MODAL_REGION_WORLD_FILTERS = [
  {
    name: 'NA - Bera, Scania, Aurora, Elysium Worlds',
    trackingName: 'NA - Non-Reboot',
    value: 'na,0'
  },
  {
    name: 'EU - Luna World',
    trackingName: 'EU - Non-Reboot',
    value: 'eu,0'
  },
  {
    name: 'NA - Reboot World',
    trackingName: 'NA - Reboot',
    value: 'na,1'
  },
  {
    name: 'EU - Reboot World',
    trackingName: 'EU - Reboot',
    value: 'eu,1'
  }
]

export default defineComponent({
  directives: {
    'observe-visibility': ObserveVisibility,
  },
  name: 'Punch King Winners',
  components: {
    Carousel,
    Slide,
    Pagination,
  },
  props: {},
  data() {
    return {
      regionToggle: 'na',
      rebootType: 0,
      carouselCharacters: _CAROUSEL_CHARACTERS,
      modalRegionWorldFilters: _MODAL_REGION_WORLD_FILTERS,
      modalRegionWorldFilter: null,
      modalJobNameFilter: null,
      navFilterTimer: null,
      scrolled: false,
      loaded: false,
      punchKingRankings: _RANKINGS,
    }
  },
  mounted() {
    Responsive.init();
    this.$nextTick(() => {
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll);

      window.dataLayer.push({
        pageType: 'Microsite',
        micrositeName: 'Punchking',
        micrositePhase: '1'
      })
    });
    setTimeout(() => {
      this.loaded = true;
    }, 210);
  },
  unmounted() {
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    filteredRankings() {
      return this.punchKingRankings.filter((ranking) => ranking.region === this.regionToggle && ranking.rebootType === this.rebootType && ranking.rank === 1).sort((a, b) => a.jobName < b.jobName ? -1 : a.jobName > b.jobName ? 1 : 0);
    },
    modalRankings() {
      const modalFilter = this.modalRegionWorldFilter.value.split(','),
        region = modalFilter[0],
        rebootType = modalFilter[1];
      return this.punchKingRankings.filter((ranking) => ranking.region === region && ranking.rebootType.toString() === rebootType);
    },
    modalJobList() {
      const jobList = new Set();
      this.modalRankings.map((ranking) => jobList.add(ranking.jobName));
      return Array.from(jobList).sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
    },
    filteredModalRankings() {
      return this.modalRankings.filter((ranking) => ranking.jobName === this.modalJobNameFilter).slice(0, 10);
    },
  },
  methods: {
    handleScroll() {
      if (this.scrolled) return;
      this.viewTracking({ id: 1, name: 'Ranking' });
      this.scrolled = true;
    },
    handleResize() {
      setTimeout(() => {
        this.$refs.pkwRewardCarousel.updateSlideWidth();
      }, 250);
    },
    setRegionToggle(region) {
      if (this.regionToggle === region) return;
      this.regionToggle = region;
      this.setFilterTimer();
    },
    setRebootType(rebootType) {
      if (this.rebootType === rebootType) return;
      this.rebootType = rebootType;
      this.setFilterTimer();
    },
    playFree(){
      Util.playFree();
      this.clickTracking({
        interaction: 'button_click',
        sectionNumber: 2,
        sectionName: 'Reward Details',
        sectionContent: 'Play Free CTA',
      })
    },
    observeVisibilitySettings(id, name, threshold = 0.3) {
      return {
        callback: (isVisible) => isVisible ? this.viewTracking({ id, name }) : null,
        intersection: { threshold: threshold },
        throttle: 1000,
        once: true,
      }
    },
    clickTracking({ interaction, sectionNumber, sectionName, sectionContent, specialValue }) {
      window.dataLayer.push({
        event: 'standardMicrositeTrackingEvent',
        interaction: interaction,
        micrositeSectionNumber: sectionNumber,
        micrositeSectionName: sectionName,
        micrositeSectionContent: sectionContent,
        ...(specialValue ? { micrositeSpecialValue: specialValue } : {}),
      });
    },
    viewTracking({ id, name }) {
        window.dataLayer.push({
          'event': 'standardMicrositeTrackingEvent',
          'interaction': 'section_view',
          'micrositeSectionNumber': id,
          'micrositeSectionName': name,
        });
    },
    goToRewards() {
      this.clickTracking({
        interaction: 'menu_click',
        sectionNumber: 0,
        sectionName: 'Header',
        sectionContent: 'Rewards'
      });
      let headerHeight = 0;
      if (!document.querySelector('body.desktop')) {
        const $header = document.querySelector('.global-header');
        headerHeight = $header ? $header.getBoundingClientRect().height : 0;
      }
      window.scrollTo({
        top: this.$refs.pkwRewards.offsetTop - this.$refs.pkwNav.getBoundingClientRect().height + headerHeight,
        behavior: 'smooth'
      });
    },
    toggleModal(toggle) {
      if (toggle) {
        this.clickTracking({ interaction: 'menu_click', sectionNumber: 0, sectionName: 'Header', sectionContent: 'Top 10' });
        this.viewTracking({ id: 3, name: 'Top 10 Popup' });
        if (window.innerWidth && document.body && document.body.clientWidth && window.innerWidth !== document.body.clientWidth) {
          document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
        }
        const regionWorldFilterValue = `${this.regionToggle},${this.rebootType}`;
        this.modalRegionWorldFilter = this.modalRegionWorldFilters.find((filter) => filter.value === regionWorldFilterValue);
        this.modalJobNameFilter = this.modalJobList[0] || '';
        document.body.classList.add('modal-active');
      } else {
        this.clickTracking({ interaction: 'button_click', sectionNumber: 3, sectionName: 'Top 10 Popup', sectionContent: 'Close Popup' });
        this.modalRegionWorldFilter = null;
        this.modalJobNameFilter = null;
        document.body.classList.remove('modal-active');
        document.body.style.paddingRight = 0;
      }
    },
    getCharacterWorld({ worldName = ''}) {
      if (!worldName) return '';
      worldName = worldName.toLowerCase();
      return worldName.includes('reboot') ? 'reboot' : worldName;
    },
    trackCarousel({ currentSlideIndex }) {
      this.clickTracking({
        interaction: 'carousel_click',
        sectionNumber: 2,
        sectionName: 'Reward Details',
        sectionContent: this.carouselCharacters[currentSlideIndex]
      });
    },
    trackModalFilter(value) {
      this.clickTracking({
        interaction: 'filter_select',
        sectionNumber: 3,
        sectionName: 'Top 10 Popup',
        sectionContent: value
      });
    },
    setFilterTimer() {
      if (this.navFilterTimer) clearTimeout(this.navFilterTimer);
      this.navFilterTimer = setTimeout(this.trackNavFilters, 1500);
    },
    trackNavFilters() {
      const navFilterValue = `${this.regionToggle},${this.rebootType}`,
        filter = this.modalRegionWorldFilters.find((filter) => filter.value === navFilterValue);
      this.clickTracking({
        interaction: 'filter_select',
        sectionNumber: 0,
        sectionName: 'Header',
        sectionContent: filter.trackingName
      });
    },
    modalRegionWorldFilterChange(filter) {
      this.trackModalFilter(filter.trackingName);
      if (!this.modalJobList.find((job) => job === this.modalJobNameFilter)) this.modalJobNameFilter = this.modalJobList[0];
    }
  },
})
</script>